import ExerciseAPI from '@/apis/business/student/exercise-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,
  state: {
    // Dữ liệu dùng submit
    submitExercise: {},
    // Dữ liệu được lấy về từ api dùng binding
    exerciseStoreField: {},
    fileManager: [],
    exerciseStatus: true, // xét trạng thái lưu nháp
    // Lưu dữ liệu bài tập để dùng cho màn hình báo nộp bài thành công
    exerciseRouteSubmit: null,
    // lưu router danh sách bài tập trước đó
    beforeRouter: null
  },

  getters: {},

  mutations: {
    clearData (state) {
      state.exerciseStoreField = {}
      state.fileManager = []
      state.submitExercise = {}
    },
    /**
     * @description clone object dùng để binding và submit
     * @param {*} state
     * @param {*} exerciseStore
     */
    setExerciseStoreField (state, exerciseStore) {
      state.exerciseStoreField = exerciseStore
    },

    /**
     * @description clone submitExerciseID với lần lưu nháp/nộp bài trước đó
     * @param {*} state
     * @param {*} submitExerciseID
     */
    setSubmitExerciseID (state, submitExerciseID) {
      state.exerciseStoreField.SubmitExerciseID = submitExerciseID
    },

    /**
     * @description xét trạng thái lưu nháp bài tập
     * @param {*} state
     * @param {*} value
     */
    setExerciseStatus (state, value) {
      state.exerciseStatus = value
    },

    /**
     * @description lưu thông tin router khi submit bài thành công
     * @param {*} state
     * @param {*} value
     */
    setExerciseRouteSubmit (state, value) {
      state.exerciseRouteSubmit = value
    },
    /**
     *@description lưu thông tin router danh sách bài tập trước đó để bac về
     * @param {*} state
     * @param {*} value
     */
    setBeforeRouter (state, value) {
      state.beforeRouter = value
    }
  },

  actions: {
    /**
     * @description truyền data câu trả lời cho vuex
     * @author BNDung
     * @param {*} context
     * @param {*} studentClassroom
     * @returns
     */
    getTaskAttachment (context, params) {
      context.commit('setTaskAttachment', params)
    },

    /** @description Lấy dữ liệu danh sách câu hỏi của học sinh được giao bài
     * @author VDDUNG1
     * @modified PBac
     * @param {*} context
     * @param {*} param
     * @returns
     */
    async getStudentExerciseQuestion (context, params) {
      return new Promise((resolve, reject) => {
        ExerciseAPI.getAsync('submit-exercise', { params: params })
          .then(res => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setExerciseStoreField', res.Data)
            }
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description hàm lưu nháp/nộp bài của học sinh
     * @author VDDung1
     * @param {*} context
     * @param {*} exerciseStoreField
     * @returns
     */
    addStudentExerciseQuestion (context, submitExercise) {
      return new Promise((resolve, reject) => {
        ExerciseAPI.postAsync('SubmitExercise', submitExercise)
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setSubmitExerciseID', res.Data.SubmitExerciseID)
            }
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
